<template>
  <ul v-if="showCovers" class="proposal-covers no-bullet">
    <li
      v-for="cover in covers"
      :key="cover.id"
      class="proposal-cover"
      data-test-proposal-basket-cover
    >
      <span class="proposal-cover__checkmark icon icon-check" />
      <span
        v-if="isAmountCover(cover) || isStaticCoverWithValue(cover)"
        data-test-cover-amount-or-static
      >
        <span v-html="cover.name" />: <span v-html="cover.value" />
      </span>
      <span
        v-else-if="isGroupedCover(cover)"
        data-test-cover-grouped
        v-html="cover.groupedCovers[0].name"
      />
      <span v-else v-html="cover.name" />
      <tooltip v-if="cover.hasTooltip" :content="cover.tooltip" />
    </li>
    <template v-if="deductibleIsPresented">
      <li data-test-deductible v-html="deductibleString" />
    </template>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { BasketProposalCover } from '@/store/modules/interfaces/ProposalBasketStoreState';

import Tooltip from '@/components/UI/Tooltip.vue';

export default defineComponent({
  name: 'ProposalCovers',
  components: {
    Tooltip
  },
  props: {
    covers: {
      type: Array as PropType<BasketProposalCover[]>,
      default() {
        return [];
      }
    },
    deductibleIsPresented: {
      type: Boolean,
      default() {
        return false;
      }
    },
    deductibleLabel: {
      type: String,
      default() {
        return '';
      }
    },
    deductibleAmount: {
      type: String,
      default() {
        return '';
      }
    }
  },
  computed: {
    deductibleString(): string {
      return this.deductibleLabel + ': ' + this.deductibleAmount;
    },
    showCovers(): boolean {
      return this.covers.length > 0;
    }
  },
  methods: {
    isAmountCover(cover: BasketProposalCover) {
      return cover.amountType;
    },
    isStaticCoverWithValue(cover: BasketProposalCover) {
      return cover.renderingType === 1 && cover.value !== '';
    },
    isGroupedCover(cover: BasketProposalCover) {
      return cover.groupedCovers;
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
.proposal-cover {
  margin: rem-calc(10) 0;

  &__checkmark {
    font-size: rem-calc(20);
  }

  > .icon-check {
    color: #05d126;
    &:before {
      font-size: rem-calc(20);
      margin-right: rem-calc(16);
    }
  }
}
</style>
